import { saveFileChanges } from "./saveFileChanges";
import { saveToFirestore } from "./saveToFirestore";
import { updateStorageInFirestore } from "./updateStorageInFirestore";

function cleanRelatedTable(project) {
  var filesToDelete = [];

  //Clean up Checklists
  project.Checklists = project.Checklists.filter((cl) => {
    if (
      !cl.hasOwnProperty("equipment_id") ||
      cl.equipment_id === null ||
      cl.equipment_id === ""
    ) {
      console.log("related table delete", cl);
      return false;
    }

    const equip = project.Equipment.find((f) => f.id === cl.equipment_id);
    if (equip === undefined) {
      console.log("related table delete", cl);
      return false;
    } else {
      return true;
    }
  });

  //Clean up Issues
  project.Issues = project.Issues.filter((cl) => {
    if (
      cl.hasOwnProperty("equipment_id") &&
      cl.equipment_id !== "" &&
      cl.equipment_id !== null
    ) {
      const equip = project.Equipment.find((f) => f.id === cl.equipment_id);
      if (equip === undefined) {
        console.log("related table delete", cl);
        return false;
      } else {
        return true;
      }
    } else if (
      cl.hasOwnProperty("observation_id") &&
      cl.observation_id !== "" &&
      cl.observation_id !== null
    ) {
      const item = project.Observations.find((f) => f.id === cl.observation_id);
      if (item === undefined) {
        console.log("related table delete", cl);
        return false;
      } else {
        return true;
      }
    } else if (
      cl.hasOwnProperty("checklist_id") &&
      cl.checklist_id !== "" &&
      cl.checklist_id !== null
    ) {
      const item = project.Checklists.find((f) => f.id === cl.checklist_id);
      if (item === undefined) {
        console.log("related table delete", cl);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  });

  //Clean up Comments
  project.Comments = project.Comments.filter((cl) => {
    if (
      cl.hasOwnProperty("equipment_id") &&
      cl.equipment_id !== "" &&
      cl.equipment_id !== null
    ) {
      const equip = project.Equipment.find((f) => f.id === cl.equipment_id);
      if (equip === undefined) {
        console.log("related table delete", cl);
        return false;
      } else {
        return true;
      }
    } else if (
      cl.hasOwnProperty("observation_id") &&
      cl.observation_id !== "" &&
      cl.observation_id !== null
    ) {
      const item = project.Observations.find((f) => f.id === cl.observation_id);
      if (item === undefined) {
        console.log("related table delete", cl);
        return false;
      } else {
        return true;
      }
    } else if (
      cl.hasOwnProperty("checklist_id") &&
      cl.checklist_id !== "" &&
      cl.checklist_id !== null
    ) {
      const item = project.Checklists.find((f) => f.id === cl.checklist_id);
      if (item === undefined) {
        console.log("related table delete", cl);
        return false;
      } else {
        return true;
      }
    } else if (
      cl.hasOwnProperty("issue_id") &&
      cl.issue_id !== "" &&
      cl.issue_id !== null
    ) {
      const item = project.Issues.find((f) => f.id === cl.issue_id);
      if (item === undefined) {
        console.log("related table delete", cl);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  });

  //Clean up Files
  project.Files = project.Files.filter((cl) => {
    if (
      cl.hasOwnProperty("equipment_id") &&
      cl.equipment_id !== "" &&
      cl.equipment_id !== null
    ) {
      const equip = project.Equipment.find((f) => f.id === cl.equipment_id);
      if (equip === undefined) {
        console.log("related table delete", cl);
        filesToDelete.push(cl);
        return false;
      } else {
        return true;
      }
    } else if (
      cl.hasOwnProperty("observation_id") &&
      cl.observation_id !== "" &&
      cl.observation_id !== "new" &&
      cl.observation_id !== null
    ) {
      const item = project.Observations.find((f) => f.id === cl.observation_id);
      if (item === undefined) {
        console.log("related table delete", cl);
        filesToDelete.push(cl);
        return false;
      } else {
        return true;
      }
    } else if (
      cl.hasOwnProperty("checklist_id") &&
      cl.checklist_id !== "" &&
      cl.checklist_id !== null
    ) {
      const item = project.Checklists.find((f) => f.id === cl.checklist_id);
      if (item === undefined) {
        console.log("related table delete", cl);
        filesToDelete.push(cl);
        return false;
      } else {
        return true;
      }
    } else if (
      cl.hasOwnProperty("issue_id") &&
      cl.issue_id !== "" &&
      cl.issue_id !== null
    ) {
      const item = project.Issues.find((f) => f.id === cl.issue_id);
      if (item === undefined) {
        console.log("related table delete", cl);
        filesToDelete.push(cl);
        return false;
      } else {
        return true;
      }
    } else if (
      cl.hasOwnProperty("comment_id") &&
      cl.comment_id !== "" &&
      cl.comment_id !== null
    ) {
      const item = project.Comments.find((f) => f.id === cl.comment_id);
      if (item === undefined) {
        console.log("related table delete", cl);
        filesToDelete.push(cl);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  });

  return { cleanProject: project, filesToDelete };
}

export async function onEditDeleteAll(
  project,
  editFeature,
  editFiles,
  tableName,
  relatedableId,
) {
  const updatedArray1 = project[tableName].filter(
    (fd) => fd.id !== editFeature.id,
  );
  project[tableName] = updatedArray1;

  //related table data
  if (tableName === "Issues") {
    project.issues_log = project.issues_log.filter(
      (log) => log.id !== editFeature.id,
    );
  }

  //find related comments to delete
  var deleteIds = project.Comments.filter(
    (c) =>
      c.hasOwnProperty(relatedableId) && c[relatedableId] === editFeature.id,
  ).map((c) => c.id);

  //remove related comments
  project.Comments = project.Comments.filter(
    (c) =>
      !c.hasOwnProperty(relatedableId) ||
      (c.hasOwnProperty(relatedableId) && c[relatedableId] !== editFeature.id),
  );

  const commentfilesToDelete = project.Files.filter(
    (f) =>
      f.hasOwnProperty("comment_id") && deleteIds.includes(f["comment_id"]),
  );
  commentfilesToDelete.forEach((f) => {
    f.deleted = true;
    editFiles.push(f);
  });

  var { cleanProject, filesToDelete } = cleanRelatedTable(project);

  filesToDelete.forEach((f) => {
    f.deleted = true;
    editFiles.push(f);
  });

  //delete any files
  editFiles.forEach((obj) => {
    obj.deleted = true;
  });

  const uniqueFilesForDelete = editFiles.filter(
    (obj, index, self) => index === self.findIndex((t) => t.file === obj.file),
  );

  const sfc = await saveFileChanges(uniqueFilesForDelete, project.uid, project.id);
  cleanProject.Files = [
    ...cleanProject.Files.filter(
      (f) =>
        !f.hasOwnProperty("deleted") ||
        (f.hasOwnProperty("deleted") && f.deleted === false),
    ),
  ];
  //Save storage changes
  if (sfc.sizeChange !== 0) {
    await updateStorageInFirestore(project.uid, sfc.sizeChange);
  }
  await saveToFirestore("projects", cleanProject);
  return cleanProject;
}
